import DraggableModal from 'components/organisms/draggableModal';
import classNames from 'classnames';
import { useFormik } from 'formik';
import { useAppDispatch } from 'store';
import { useStoreModalValue } from 'components/organisms/rpm-alert-assessment-modal/hooks/use-store-modal-value';

import { maCriticalTemplate } from './templates/ma-red';
import s from './components/styles.module.scss';
import styles from './styles.module.scss';
import { maCritical } from './blurbs/ma-red';
import MaCriticalFormItem from './components/ma-critical-form-item';

import type { IMaCriticalData } from './types';
import type { FC } from 'react';

interface MaCriticalReadingTemplateProps {
  toggle: () => void;
  idx: string | number;
}

const MaCriticalReadingTemplate: FC<MaCriticalReadingTemplateProps> = ({
  toggle,
  idx,
}) => {
  const {
    activityActions: { updateAction },
  } = useAppDispatch();
  const { parsedData, setModalValuesToStorage } =
    useStoreModalValue<IMaCriticalData>({
      idx,
      type: null,
      modalName: 'maCritical',
    });

  const formik = useFormik<IMaCriticalData>({
    initialValues: parsedData ?? {},
    onSubmit: (data) => {
      const generatedBlurb = maCritical(data);
      const blurb = generatedBlurb.startsWith('\n')
        ? generatedBlurb.slice(1)
        : generatedBlurb;
      // Another source replaced the message: drop any Nurse-MA template answers.
      updateAction({
        idx,
        action: { message: blurb, criticalReadingTemplate: undefined },
      });
      setModalValuesToStorage(data);
      toggle();
    },
    validateOnChange: false,
  });

  return (
    <>
      <DraggableModal
        title="Chart Review: Critical Vital(s)"
        isOpen
        toggle={toggle}
        onSave={() => formik.submitForm()}
      >
        <div className={styles['ma-critical-wrapper']}>
          {maCriticalTemplate?.map((formItem) => {
            return (
              <div className={classNames(s.item)} key={formItem.key}>
                <MaCriticalFormItem item={formItem} formik={formik} />
              </div>
            );
          })}
        </div>
      </DraggableModal>
    </>
  );
};
export default MaCriticalReadingTemplate;
